<template>
  <AgreementComponets></AgreementComponets>
</template>

<script>
import AgreementComponets from '@/components/Agreement'

export default {
  data () {
    return {
    }
  },
  props: [
  ],
  methods: {
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
  },
  components: {
    AgreementComponets
  }
}
</script>
